<template>
  <div class="method-selector-container">
    <div class="title-container">Portal de validación de Identidad</div>
    <div v-if="validationPurpose" id="validation-purpose" class="validation-purpose-container">
      <Texting format="body" bold class="validation-purpuse-text">Estás validando tu identidad para:</Texting>
      <Texting format="h6" class="validation-purpuse-text-2">
        {{ validationPurpose }}
      </Texting>
    </div>
    <div class="subtitle-container">
      <Texting format="h6" class="subtitle-container-text">¿Cómo quieres validar tu identidad?</Texting>
    </div>
    <div class="validation-methods-container">
      <div
        v-bind:class="{
          'pds-card': true,
          'validation-card': method.retries > 0,
          'validation-card-disabled': method.retries == 0,
        }"
        v-for="method in validationMethods()"
        :key="method.method"
      >
        <div></div>
        <div class="validation-title">
          <Texting format="body2" bold>
            {{ method.title }}
          </Texting>
        </div>

        <div class="validation-information">
          <div class="retries-container">
            <div v-if="method.retries > 1">
              <vue-feather class="alert-icon" type="alert-circle" size="24"></vue-feather>
              <Texting format="body4" bold class="retries-text-pds">Tienes {{ method.retries }} intentos</Texting>
            </div>
            <div v-else-if="method.retries == 1">
              <vue-feather type="alert-circle" stroke="#c00000" size="24"></vue-feather>
              <Texting format="body4" bold class="retries-text-red-pds">
                Tienes {{ method.retries }} intento más
              </Texting>
            </div>
            <div v-else>
              <vue-feather type="x" stroke="#c00000" size="24"></vue-feather>
              <Texting format="body4" bold class="retries-text-disabled-pds">No tienes más intentos</Texting>
            </div>
          </div>
          <Texting format="body5" class="validation-hint">
            {{ method.description }}
          </Texting>
        </div>
        <div class="validation-button">
          <PdsButton label="Ingresa aquí" :disabled="method.retries == 0" @click="beginValidation(method.method)" />
        </div>
      </div>
      <div v-if="!isPartialPortal" class="help-link"><a href="#">Necesito ayuda de un asesor</a></div>
    </div>
    <div class="information-container ">
      <p class="information-text">
        Al seleccionar "Ingresa Aquí" estarás aceptando el tratamiento de tus datos personales de identificación, biométricos y de contacto.
        <br/>
        <br/>
        Al seleccionar “Ingresa Aquí”, estarás entregando tus datos personales de identificación, biométricos y de contacto para realizar el proceso de validación de identidad asociado a este trámite.
        El tratamiento de estos datos será realizado acorde con las leyes vigentes para el tratamiento de datos personales en Chile.  Los datos capturados serán eliminados al término del proceso de validación de identidad y sólo se mantendrá un registro (log) con la traza del evento y el resultado de la validación. Este registro será almacenado por el tiempo que requiere la ley para procesos de verificación.
        Para más información sobre el tratamiento de tus datos personales puedes leer nuestra <a class="fulfillment-link" href="https://principal.cl/politica-de-privacidad" >Política de protección de datos personales</a>.
      </p>
    </div>
  </div>
</template>

<script>
import VueFeather from "vue-feather";
import PdsButton from "@vue-pds/button";
import Texting from "@vue-pds/texting";
import AuthPortalConstants from "@/components/authPortal/constants/AuthPortalConstant";

const eventName = "MethodSelectorResponse";
export default {
  name: "MethodValidator",
  components: {
    VueFeather,
    PdsButton,
    Texting,
  },
  props: {
    validations: { type: Array, required: true },
    isPartialPortal: { type: Boolean, default: false },
    validationPurpose: { type: String },
  },
  methods: {
    validationMethods() {
      let methods = [];
      for (const validation in this.validations) {
        if (this.validations[validation].method === AuthPortalConstants.AuthMethods.QUESTIONS) {
          methods.push({
            method: this.validations[validation].method,
            title: AuthPortalConstants.QUESTIONS.title,
            retries: this.validations[validation].left,
            description: AuthPortalConstants.QUESTIONS.description,
          });
        }
        else if (this.validations[validation].method === AuthPortalConstants.AuthMethods.FACIALRECOGNITION) {
          methods.push({
            method: this.validations[validation].method,
            title: AuthPortalConstants.FACIALRECOGNITION.title,
            retries: this.validations[validation].left,
            description: AuthPortalConstants.FACIALRECOGNITION.description,
          });
        }
        else if (this.validations[validation].method === AuthPortalConstants.AuthMethods.UNIQUESTATEPASSWORD) {
          methods.push({
            method: this.validations[validation].method,
            title: AuthPortalConstants.UNIQUESTATEPASSWORD.title,
            retries: this.validations[validation].left,
            description: AuthPortalConstants.UNIQUESTATEPASSWORD.description,
          });
        }
        else if (this.validations[validation].method === AuthPortalConstants.AuthMethods.ECERTADVANCEDSIGN) {
          methods.push({
            method: this.validations[validation].method,
            title: AuthPortalConstants.ECERTADVANCEDSIGN.title,
            retries: this.validations[validation].left,
            description: AuthPortalConstants.ECERTADVANCEDSIGN.description,
          });
        }
      }
      return methods;
    },
    beginValidation(selectedMethod) {
      var response = { selectedMethod };
      if (selectedMethod === AuthPortalConstants.AuthMethods.QUESTIONS) {
        response.internalName = AuthPortalConstants.QUESTIONS.internalName;
      }
      else if (selectedMethod === AuthPortalConstants.AuthMethods.FACIALRECOGNITION) {
        response.internalName = AuthPortalConstants.FACIALRECOGNITION.internalName;
      }
      else if (selectedMethod === AuthPortalConstants.AuthMethods.ECERTADVANCEDSIGN) {
        response.internalName = AuthPortalConstants.ECERTADVANCEDSIGN.internalName;
      }
      else {
        response.internalName = AuthPortalConstants.UNIQUESTATEPASSWORD.internalName;
      }
      this.$emit(eventName, response);
    },
  },
};
</script>

<style scoped src="@pds/card/card.min.css"></style>
<style scoped src="@pds/button/button.min.css"></style>
<style scoped src="@pds/typography/typography.min.css"></style>
<style scoped>
.method-selector-container {
  padding-top: 60px;
  min-height: 650px;
}
.title-container {
  width: 100%;
  font-size: 50px;
  line-height: 66px;
  font-weight: bold;
  align-items: center;
  text-align: center;
  color: #000000;
}
.subtitle-container {
  width: 100%;
  text-align: center;
  color: #4a4a4a;
  padding-top: 15px;
}
.validation-methods-container {
  padding-top: 31px;
  max-width: 600px;
  text-align: center;
  margin: auto;
}
.validation-card {
  min-height: 171px;
  display: inline-block;
  margin-bottom: 10px;
}
.validation-card-disabled {
  min-height: 171px;
  display: inline-block;
  margin-bottom: 10px;
  background: #f6f6f8;
}
.validation-title {
  text-align: left;
  color: #04508a;
  margin: 22px 0px 0px 18px;
  width: 100%;
}

.validation-card-disabled .validation-title {
  color: #92949a;
}
.validation-information {
  width: 60%;
  float: left;
  text-align: left;
  padding-left: 17px;
  padding-top: 6px;
}

.information-container {
  padding-top: 31px;
  max-width: 600px;
  text-align: left;
  margin: auto;
}
.information-title {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 0px;
}
.information-text {
  margin-top: 7px;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
}

.retries-container {
  width: 100%;
  vertical-align: center;
}

.retries-text-pds {
  padding-left: 10px;
  vertical-align: top;
  display: inline;
}

.validation-hint {
  width: 100%;
  margin-top: 15px;
  line-height: 18px;
  color: #4a4a4a;
}
.validation-card-disabled .validation-hint {
  color: #92949a;
}
.validation-button {
  width: 30%;
  float: right;
  padding-top: 17px;
}
.help-link {
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 18px;
}
.retries-text-red-pds {
  color: #c00000;
  padding-left: 10px;
  vertical-align: top;
  display: inline;
}

.retries-text-disabled-pds {
  color: #92949a;
  padding-left: 10px;
  vertical-align: top;
  display: inline;
}

.validation-purpose-container {
  width: 100%;
  text-align: center;
  align-content: center;
  align-items: center;
  padding-top: 15px;
  padding-left: 5px;
  padding-right: 5px;
}

.validation-purpuse-text {
  display: inline;
}

.validation-purpuse-text-2 {
  display: inline;
}

.fulfillment-href {
  text-decoration: underline;
  cursor: pointer;
}

.fulfillment-link {
  color: #0091da;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  padding-top: 10px;
}

@media only screen and (min-width: 700px) and (max-width: 1150px) {
  .title-container {
    font-size: 40px;
  }
  .method-selector-container {
    padding-bottom: 120px;
    min-height: max-content;
  }
  .subtitle-container-text {
    font-size: 22px;
  }

  .validation-purpuse-text {
    font-size: 20px !important;
  }

  .validation-purpuse-text-2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 700px) {
  .method-selector-container {
    padding-top: 37px;
    padding-bottom: 48px;
    min-height: auto;
  }
  .title-container {
    font-size: 30px;
    line-height: 46px;
  }
  .subtitle-container {
    font-size: 16px;
    line-height: 21px;
    padding-top: 8px;
  }
  .validation-methods-container {
    padding-top: 17px;
    min-width: 345px;
    max-width: 85%;
  }
  .validation-information {
    width: 95%;
    padding-left: 20px;
    padding-right: 9px;
    float: none;
  }
  .validation-button {
    width: 100%;
    text-align: left;
    float: none;
    padding: 17px 0px 31px 20px;
  }
  .validation-button {
    float: none;
  }
  .help-link {
    padding-left: 5px;
  }
  .subtitle-container-text {
    font-size: 16px !important;
  }
  .validation-purpuse-text {
    font-size: 16px !important;
    display: block;
  }
  .validation-purpuse-text-2 {
    font-size: 22px !important;
    display: block;
  }
}
</style>
